/**
 * Which guide phrases name a place on screen, and where that place is.
 *
 * Split out of demoJargon.tsx rather than living beside DEMO_JARGON because
 * that file exports the JargonText component and react-refresh wants component
 * files to export only components — same reason inspectorTabs.ts is separate
 * from InspectorTabStrip.tsx.
 *
 * Only phrases with a physical location belong here. Concepts like "peel chain"
 * or "smurfing" stay hover-only explainers: there is nothing to point at.
 *
 * Keys must exist in DEMO_JARGON — the matcher only annotates phrases from that
 * dictionary, so a pointer keyed off anything else is dead on arrival. That
 * pairing is asserted in tour/uiLocator.test.tsx.
 */
import type { UiLocationKey } from './uiLocations';

export const JARGON_LOCATIONS: Record<string, UiLocationKey> = {
    // Panels and surfaces
    'Node Inspector': 'node-inspector',
    'Inspector chips': 'identity-chips',
    chips: 'identity-chips',
    'Triage Ribbon': 'identity-chips',
    canvas: 'graph-canvas',
    Omnibar: 'omnibar',

    // Inspector tabs
    'Overview tab': 'inspector-tab-overview',
    'Parties tab': 'inspector-tab-parties',
    'Transfers tab': 'inspector-tab-transfers',
    'Activity tab': 'inspector-tab-transfers',
    'Intel tab': 'inspector-tab-intel',
    'Intelligence tab': 'inspector-tab-intel',
    'Analysis tab': 'inspector-tab-analysis',
    'Actions tab': 'inspector-tab-actions',
    'Forensic tab': 'inspector-tab-forensic',

    // Tools and controls
    'Edge Actions': 'edge-context-menu',
    'Fund Flow Playback': 'canvas-playback',
    'Pattern Scan': 'analysis-macro',
    'AI Summary': 'analysis-macro',
    'Auto-Trace': 'header-trace',
    'Gold Path': 'header-trace',
    'Follow the Money': 'analysis-follow-money',
    'Find Links': 'header-links',
    Legend: 'canvas-legend',
    minimap: 'canvas-minimap',
    Recompute: 'canvas-recompute',
    'Rearrange as': 'canvas-layout-modes',
    'graph filters': 'graph-filters',
    'Undo/Redo': 'header-undo-redo',
    'LE Report': 'le-report',
    'Case wallets': 'wb-case-wallets',
    'Promote to case': 'wb-promote-to-case',

    // Fusion Canvas
    Palette: 'fusion-palette',
    'Court-safe': 'fusion-court-safe',
    'Court-safe Chain': 'fusion-aside-ledger',
    'Surface filters': 'fusion-surface-filters',
    Timeline: 'fusion-timeline',
    'Ingestion Timeline': 'fusion-timeline',
    'Ingestion timeline': 'fusion-timeline',
    'Play stages': 'fusion-timeline',
    'Fusion Inspector': 'fusion-inspector',
    'Bank import': 'fusion-aside-import',
    'Case files': 'fusion-aside-files',
    'New case': 'fusion-new-case',
    'Open case': 'fusion-open-case',
    'Create a new case': 'fusion-welcome-new-case',
    'Explore demos': 'fusion-welcome-demos',
    'Build tab': 'fusion-tab-build',
    'Journal tab': 'fusion-tab-journal',
    'Run rail': 'fusion-run-rail',
    'Clear focus': 'case-clear-focus',
    Autopilot: 'fusion-palette',
};
